import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow } from "../master/Master";
import Master from "./Master";
import { busReport } from "../../api/Transport";

export default function TransportReport() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [sessions, setSessions] = useState([]);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    try {
      const parseSessions = JSON.parse(
        localStorage.getItem("sessions") ?? "[]",
      );

      setSessions(Array.isArray(parseSessions) ? parseSessions : []);
    } catch (error) {
      setSessions([]);
    }
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) {
        return prev;
      }

      return {
        ...prev,
        session_id: activeSession,
      };
    });
  }, [sessions]);

  const getReport = async () => {
    setLoading(true);
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value && value !== "all") {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    try {
      const response = await busReport(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data || {});
      } else {
        setData({});
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "No report found",
        );
      }
    } catch (error) {
      setData({});
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message ??
          "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filters?.session_id) {
      getReport();
    }
  }, [filters?.session_id]);

  const summary = data?.summary || {};
  const busWise = Array.isArray(data?.bus_wise) ? data.bus_wise : [];
  const formatMoney = (value = 0) => {
    return `₹ ${Number(value || 0).toLocaleString("en-IN")}`;
  };

  const percentage = (value, total) => {
    if (!Number(total)) return 0;
    return Math.min(
      100,
      Math.max(0, (Number(value || 0) / Number(total)) * 100),
    );
  };

  const StatCard = ({ icon, label, value, tone = "primary" }) => (
    <div className="col-6 col-xl-3">
      <div
        className="card border-0 shadow-sm h-100"
        style={{
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        <div className="card-body p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className={`bg-label-${tone} d-flex align-items-center justify-content-center`}
              style={{
                width: 48,
                height: 48,
                minWidth: 48,
                borderRadius: "14px",
                fontSize: 22,
              }}
            >
              <i className={icon}></i>
            </div>

            <div className="flex-grow-1">
              <div
                className="text-muted"
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {label}
              </div>

              {loading ? (
                <div
                  className="placeholder-glow mt-2"
                  style={{ width: "80px" }}
                >
                  <span className="placeholder col-12 rounded"></span>
                </div>
              ) : (
                <div
                  className="fw-bold mt-1"
                  style={{
                    fontSize: 21,
                    lineHeight: 1.2,
                  }}
                >
                  {value}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const TableSkeleton = () => (
    <>
      {[1, 2, 3, 4].map((item) => (
        <tr key={item}>
          {Array.from({ length: 9 }).map((_, index) => (
            <td key={index}>
              <span className="placeholder-glow">
                <span
                  className="placeholder col-10"
                  style={{
                    height: 14,
                    borderRadius: 5,
                  }}
                />
              </span>
            </td>
          ))}
        </tr>
      ))}
    </>
  );

  const EmptyState = () => (
    <div className="text-center py-5">
      <div
        className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
        style={{
          width: 75,
          height: 75,
          fontSize: 32,
        }}
      >
        <i className="ri-bus-line text-muted"></i>
      </div>

      <h6 className="fw-bold mb-1">No Bus Data Found</h6>

      <p className="text-muted mb-0">
        No transport records are available for this session.
      </p>
    </div>
  );

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row py-5">
                  <Master />
                  <div className="col-md-12">
                    <div className="card border-0 shadow-sm rounded-4 p-3 mb-3">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              width: 52,
                              height: 52,
                              borderRadius: 15,
                              background:
                                "linear-gradient(135deg,#185fa5,#4f8cff)",
                              color: "#fff",
                              fontSize: 24,
                              boxShadow: "0 5px 15px rgba(24,95,165,.25)",
                            }}
                          >
                            <i className="ri-bus-2-line"></i>
                          </div>

                          <div>
                            <h5 className="m-0 fw-bold">Transport Report</h5>

                            <small className="text-muted">
                              Bus, student & fee overview
                            </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          <i className="ri-calendar-line text-muted"></i>

                          <select
                            className="form-select"
                            style={{
                              minWidth: 190,
                              borderRadius: 10,
                            }}
                            value={filters?.session_id || ""}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                session_id: e.target.value,
                              })
                            }
                          >
                            {sessions.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.session}
                                {Number(item.status) === 1 ? " (Active)" : ""}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row g-3 mb-3">
                      <StatCard
                        icon="ri-bus-2-line"
                        label="Total Buses"
                        value={summary?.total_buses || 0}
                        tone="primary"
                      />

                      <StatCard
                        icon="ri-bus-wifi-line"
                        label="Active Buses"
                        value={summary?.active_buses || 0}
                        tone="success"
                      />

                      <StatCard
                        icon="ri-map-pin-line"
                        label="Active Bus Stops"
                        value={summary?.active_bus_stops || 0}
                        tone="info"
                      />

                      <StatCard
                        icon="ri-group-line"
                        label="Transport Students"
                        value={summary?.students || 0}
                        tone="warning"
                      />

                      <StatCard
                        icon="ri-money-rupee-circle-line"
                        label="Total Fee"
                        value={formatMoney(summary?.total_fee)}
                        tone="primary"
                      />

                      <StatCard
                        icon="ri-price-tag-3-line"
                        label="Total Discount"
                        value={formatMoney(summary?.total_discount)}
                        tone="warning"
                      />

                      <StatCard
                        icon="ri-checkbox-circle-line"
                        label="Total Paid"
                        value={formatMoney(summary?.total_paid)}
                        tone="success"
                      />

                      <StatCard
                        icon="ri-wallet-3-line"
                        label="Total Due"
                        value={formatMoney(summary?.total_due)}
                        tone="danger"
                      />
                    </div>

                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                      <div className="card-header bg-white border-0 p-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className="bg-label-primary d-flex align-items-center justify-content-center rounded-3"
                              style={{
                                width: 42,
                                height: 42,
                                fontSize: 20,
                              }}
                            >
                              <i className="ri-bus-2-line"></i>
                            </div>

                            <div>
                              <h6 className="fw-bold mb-0">Bus Wise Report</h6>

                              <small className="text-muted">
                                Students and fee details by bus
                              </small>
                            </div>
                          </div>

                          {!loading && (
                            <span className="badge bg-label-primary px-3 py-2">
                              {busWise.length} Bus
                              {busWise.length !== 1 ? "es" : ""}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table align-middle mb-0">
                          <thead
                            style={{
                              background: "#f8f9fa",
                            }}
                          >
                            <tr>
                              <th className="ps-4">#</th>
                              <th>Bus</th>
                              <th>Driver</th>
                              <th>Students</th>
                              <th>Total Fee</th>
                              <th>Discount</th>
                              <th>Final Fee</th>
                              <th>Paid</th>
                              <th>Due</th>
                            </tr>
                          </thead>

                          <tbody>
                            {loading ? (
                              <TableSkeleton />
                            ) : busWise.length > 0 ? (
                              busWise.map((bus, index) => {
                                const paidPercentage = percentage(
                                  bus?.total_paid,
                                  bus?.final_fee,
                                );

                                return (
                                  <tr key={bus?.bus_id || index}>
                                    <td className="ps-4">
                                      <span
                                        className="d-flex align-items-center justify-content-center bg-light rounded-circle fw-semibold"
                                        style={{
                                          width: 32,
                                          height: 32,
                                        }}
                                      >
                                        {index + 1}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="bg-primary-subtle text-primary d-flex align-items-center justify-content-center rounded-3"
                                          style={{
                                            width: 40,
                                            height: 40,
                                          }}
                                        >
                                          <i className="ri-bus-line fs-5"></i>
                                        </div>
                                        <div>
                                          <div className="fw-bold">
                                            {bus?.bus_number || "-"}
                                          </div>
                                        </div>
                                      </div>
                                    </td>

                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="bg-light rounded-circle d-flex align-items-center justify-content-center"
                                          style={{
                                            width: 34,
                                            height: 34,
                                          }}
                                        >
                                          <i className="ri-user-line text-muted"></i>
                                        </div>

                                        <span className="fw-semibold">
                                          {bus?.driver_name || "Not Assigned"}
                                        </span>
                                      </div>
                                    </td>

                                    {/* Students */}

                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <i className="ri-group-line text-primary"></i>

                                        <span className="fw-bold">
                                          {bus?.students || 0}
                                        </span>
                                      </div>
                                    </td>

                                    {/* Total Fee */}

                                    <td>
                                      <span className="fw-semibold">
                                        {formatMoney(bus?.total_fee)}
                                      </span>
                                    </td>

                                    {/* Discount */}

                                    <td>
                                      <span className="badge bg-label-warning">
                                        <i className="ri-price-tag-3-line me-1"></i>

                                        {formatMoney(bus?.total_discount)}
                                      </span>
                                    </td>

                                    {/* Final Fee */}

                                    <td>
                                      <span className="fw-bold">
                                        {formatMoney(bus?.final_fee)}
                                      </span>
                                    </td>

                                    {/* Paid */}

                                    <td>
                                      <div className="fw-bold text-success">
                                        {formatMoney(bus?.total_paid)}
                                      </div>

                                      <div
                                        className="progress mt-1"
                                        style={{
                                          height: 5,
                                          width: 75,
                                        }}
                                      >
                                        <div
                                          className="progress-bar bg-success"
                                          style={{
                                            width: `${paidPercentage}%`,
                                          }}
                                        />
                                      </div>
                                    </td>

                                    {/* Due */}

                                    <td>
                                      <span className="fw-bold text-danger">
                                        {formatMoney(bus?.total_due)}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9">
                                  <EmptyState />
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
